import { useState } from 'react';
import { Bell, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

// SS11: header notification bell (admin). Shows pending client/engagement request
// counts in a small popover, replacing the old bottom-of-nav megaphone note.
export function NotificationBell({ pendingClients, pendingEngagements }: { pendingClients: number; pendingEngagements: number }) {
  const [open, setOpen] = useState(false);
  const total = pendingClients + pendingEngagements;
  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        title="Notifications"
        aria-label="Notifications"
        className="relative flex h-9 w-9 items-center justify-center rounded-full text-primary transition-colors hover:bg-secondary"
      >
        <Bell className="h-5 w-5" />
        {total > 0 && <span className="absolute right-1.5 top-1.5 h-2 w-2 rounded-full bg-destructive" />}
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 z-50 mt-2 w-72 rounded-lg border border-border bg-card p-3 shadow-xl">
            <div className="mb-2 text-xs font-semibold uppercase tracking-wide text-muted-foreground">Notifications</div>
            {total === 0 ? (
              <p className="text-sm text-muted-foreground">No pending requests.</p>
            ) : (
              <Link
                to="/pending"
                onClick={() => setOpen(false)}
                className="flex items-center justify-between gap-2 rounded-md p-2 text-sm hover:bg-secondary"
              >
                <span>{pendingClients} pending client &amp; {pendingEngagements} pending engagement requests</span>
                <ArrowRight className="h-4 w-4 shrink-0 text-primary" />
              </Link>
            )}
          </div>
        </>
      )}
    </div>
  );
}
